import { APPLICATIONS, INITIAL_UPGRADE_VERSION } from '../constant/constant';
import { selectedVersionPayload } from '../constant/types';

const initialState = {
  oldVersion: INITIAL_UPGRADE_VERSION,
  oldLoading: false,
  upgradeApplicationChoice: APPLICATIONS.STUDIOBFF,
  sourceRegion: 'us-dev',
  newVersion: INITIAL_UPGRADE_VERSION,
  newLoading: false,
};

export const addUpgradeEnvironmentsReducer = (
  state = initialState,
  action: { type: string; payload: string | selectedVersionPayload | boolean },
) => {
  switch (action.type) {
    case 'UPGRADE_APPLICATION':
      return { ...state, upgradeApplicationChoice: action.payload };
    case 'SOURCE_REGION':
      return { ...state, sourceRegion: action.payload };
    case 'OLD_VERSION':
      return { ...state, oldVersion: action.payload };
    case 'OLD_LOADING':
      return { ...state, oldLoading: action.payload };
    case 'NEW_LOADING':
      return { ...state, newLoading: action.payload };
    case 'NEW_VERSION':
      return { ...state, newVersion: action.payload };
    default:
      return state;
  }
};
